import React, { useContext } from 'react'
import { TranslateContext } from 'client/common/translator'

const Phytopharma = ({ lang }) => {
  const t = useContext(TranslateContext)
  const link = lang === 'fr' ? '/fr/makers/t/produits_phytopharmaceutiques' : '/nl/makers/t/gewasbeschermingsmiddelen'
  return (
    <a href={link}>
      <div className='mxd-legal-phytopharma'>
        <img
          className='mxd-legal-phytopharma-icon'
          src='//d3ufyq13vbk1ak.cloudfront.net/logo/legacy-phytopharma.svg'
          alt='phytopharma logo'
        />
        <span className='mxd-legal-phytopharma-text'>{t('product_phytopharma')}</span>
      </div>
    </a>
  )
}

export default Phytopharma
